import { getLogger } from '../gaia-data/init';

function findLocalization(localizations, languages) {
  var useInterfaceLanguage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  return getLocalizedNode(localizations, languages, useInterfaceLanguage);
}

function getLocalizedContentText(localizations, languages) {
  var useInterfaceLanguage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var localization = findLocalization(localizations, languages, useInterfaceLanguage);
  return localization ? localization.text : null;
}

var getLocalizedNode = function getLocalizedNode(localizations, languages) {
  var useInterfaceLanguage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (!languages || !Array.isArray(localizations)) {
    getLogger().error('Missing languages or localization array');
    return null;
  }
  var locale = languages.interfaceLanguage;
  var learningLanguage = languages.learningLanguage;
  // Per comments on CD-327, logic for delivering localization is as follows:
  // Localize in L1 (xx-YY)
  // If we don't have it, use L1 (xx)
  // If we don't have it, use the browser/device locale (xx-YY first, then try xx)
  // If we don't have it, use L2 (xx-YY)
  // If we don't have it, use L2 (xx)
  // If we don't have it, default to en-YY (either -GB or -US)
  // If we still don't have it, nothing renders

  var found = void 0;
  if (!useInterfaceLanguage) {
    found = localizations.find(function (node) {
      return node.locale.startsWith(learningLanguage) || node.locale.startsWith(learningLanguage.split('-')[0]);
    });
  }
  if (locale) {
    found = localizations.find(function (node) {
      return node.locale.startsWith(locale);
    });
  }
  if (!found && locale) {
    found = localizations.find(function (node) {
      return node.locale.startsWith(locale.split('-')[0]);
    });
  }
  if (!found && navigator.language) {
    found = localizations.find(function (node) {
      return node.locale.startsWith(navigator.language) || node.locale.startsWith(navigator.language.split('-')[0]);
    });
  }
  if (!found && learningLanguage) {
    found = localizations.find(function (node) {
      return node.locale.startsWith(learningLanguage);
    });
  }
  if (!found && learningLanguage) {
    found = localizations.find(function (node) {
      return node.locale.startsWith(learningLanguage.split('-')[0]);
    });
  }
  if (!found) {
    found = localizations.find(function (node) {
      return node.locale.startsWith('en');
    });
  }
  return found;
};

export var localizationModel = {
  findLocalization: findLocalization,
  getLocalizedContentText: getLocalizedContentText,
  getLocalizedNode: getLocalizedNode
};